import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { InternalUserV2Input, InternalUserV2UpdateInput, InternalUserV2Output } from './models/internal-user.model';

@Injectable({
  providedIn: 'root'
})
export class InternalUserService {
  private apiUrl = `${environment.apiUrl}/v2/users`;

  constructor(private http: HttpClient) { }

  getAll(): Observable<InternalUserV2Output[]> {
    return this.http.get<InternalUserV2Output[]>(this.apiUrl, { observe: 'response' }).pipe(
      map(response => {
        if (response.status !== 200) {
          throw new Error('Erro ao buscar usuários.');
        }
        return response.body || [];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }

  getById(id: string): Observable<InternalUserV2Output> {
    const url = `${this.apiUrl}/${id}`;
    return this.http.get<InternalUserV2Output>(url, { observe: 'response' }).pipe(
      map(response => {
        if (response.status !== 200) {
          throw new Error('Erro ao buscar usuário.');
        }
        return response.body!;
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }

  create(user: InternalUserV2Input): Observable<InternalUserV2Output> {
    return this.http.post<InternalUserV2Output>(this.apiUrl, user, { observe: 'response' }).pipe(
      map(response => {
        if (response.status !== 201) {
          throw new Error('Erro ao criar usuário.');
        }
        return response.body!;
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }

  update(id: string, user: InternalUserV2UpdateInput): Observable<InternalUserV2Output> {
    const url = `${this.apiUrl}/${id}`;
    return this.http.put<InternalUserV2Output>(url, user, { observe: 'response' }).pipe(
      map(response => {
        if (response.status !== 200) {
          throw new Error('Erro ao atualizar usuário.');
        }
        return response.body!;
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }

  delete(id: string): Observable<void> {
    const url = `${this.apiUrl}/${id}`;
    return this.http.delete(url, { observe: 'response' }).pipe(
      map(response => {
        if (response.status !== 204) {
          throw new Error('Erro ao deletar usuário.');
        }
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }
}

